import { TemplateResult, html } from "lit";

export const helpOverlayText: TemplateResult = html`
    <h2>HELP MENU</h2>

    “Into the Shadows” is a text-based adventure game where you, the player, make choices to progress through
    the story.
    <br /><br />
    Each choice you make will lead to different outcomes, shaping the course of your adventure.
    <br /><br />
    The goal is to reach the end of the story by making strategic decisions.
    <br /><br />
    <h3>How to get started:</h3>
    - To begin your adventure, click on the “TO MAIN DIALOGUE” button. Read the dialogues and choose the
    option you think is best.<br />
    - You'll be presented with choices at various points in the game. Use your instincts and imagination to
    guide your decisions.

    <h4>Button controls:</h4>

    At the bottom of the screen you will find the action buttons, you can use these buttons to do certain
    actions inside the game, every button will be explained below.
    <br /><br />
    USE - The “USE” action, shown with the “Hand” symbol is activated when clicking on the corresponding
    button. After clicking this action button you can click on an item in the inventory to activate the “USE”
    action on that specific item.
    <br /><br />
    EXAMINE - The “EXAMINE” action, shown with the “EYE” symbol is activated when clicking on the
    corresponding button. After clicking this action button you can click on an item in the inventory to
    activate the “EXAMINE” action on that specific item.
    <br /><br />
    PLAYER MAP - The “PLAYER MAP” action, shown with the “FOLDED MAP” symbol is activated when clicking on the
    corresponding button. After clicking this action button the player map will show up. Here you can find the
    room's that you've unlocked through the story. Simply click on one of the rooms to go to that specific
    room. By progressing through the game you will unlock new rooms to go and get back to.
    <br /><br />
    MAIN MENU - The “MAIN MENU” action, shown with the “3 VERTICAL STRIPES” symbol is activated when clicking
    on the corresponding button. After clicking this action button you will be redirected to the main menu.
    <br /><br />
    HELP MENU - The “HELP MENU” action, shown with the “QUESTION MARK” symbol is activated when clicking on
    the corresponding button. After clicking this action button you will open up the help menu, which is the
    one you are looking at right now.

    <h4>Making Choices:</h4>

    - When prompted with choices, simply click on the choice you seem fit.<br />
    - There is a possibility that an option is disabled conditionally by the decisions you made.<br />
    - There is always a way to succeed in each room, so think creatively and good luck puzzling!

    <h4>Exploring the Story:</h4>

    - Pay attention to the descriptions provided as they contain clues and hints about what might happen
    next.<br />
    - Choices you make can have consequences, so think carefully before deciding.<br />
    - Some choices may lead to success, while others could result in failure or unexpected twists.

    <h4>Progressing Through the Game:</h4>

    - Your journey will unfold based on the decisions you make.<br />
    - Don't worry if you encounter challenges or setbacks; they're all part of the adventure!<br />
    - If you reach a dead end or fail a challenge, don't be discouraged. You can always start again and try a
    different approach.

    <h4>Enjoying the Experience:</h4>
    - “Into the Shadows” is all about immersing yourself in a thrilling adventure. - Let your imagination run
    wild as you envision the world and characters around you.<br />
    - Embrace the excitement of uncertainty and unpredictability as you shape your own unique story. Feedback
    and Suggestions:<br />
    - If you have any feedback or suggestions for improving the game, feel free to share them with the
    developer.<br />
    - Your input is valuable and can help enhance the overall gaming experience for yourself and others.

    <h4>Have Fun!:</h4>

    - Above all, remember to have fun and enjoy the journey!<br />
    - “Into the Shadows” is designed to provide hours of entertainment and excitement as you embark on your
    epic adventure.
`;
